import React from 'react'
import { Control } from 'react-hook-form'
import { FormItem } from 'vnetwork-ui'
import { TicketSecurityTagOptions } from '../../../types/utils'

interface Props {
    control: Control<any>
}

/**
 * IT-ISMS: Security classification tag selector per QT-01 §4.2 (tag kép).
 * Values: None (default), Security, Service, Both.
 */
const TicketSecurityTag: React.FC<Props> = ({ control }) => {
    return (
        <FormItem
            control={control}
            name="ticket_security_tag"
            type="select"
            label="Security Tag (IT-ISMS)"
            options={TicketSecurityTagOptions()}
            placeholder="Select security classification"
        />
    )
}

export default TicketSecurityTag
